import dai_icon from '../images/coins/dai.svg';
import ether_icon from '../images/coins/ethereum-icon.svg';
import usdc_icon from '../images/coins/us-dollar-coin-icon.svg';
import mkr_icon from '../images/coins/maker-icon.svg';


export const tempWallet = [
    {
        name: 'Native Ether',
        address: '0x0000000000000000000000000000000000000000',
        symbol: 'ETH',
        decimals: 18,
        chainId: 3,
    amount: "1.64M",
        value: "223,185.3",
        logoURI:
          ether_icon,
      },
      {
        name: 'Wrapped BTC',
        address: '0x442be68395613bdcd19778e761f03261ec46c06d',
        symbol: 'WBTC',
        decimals: 8,
          chainId: 3,
        amount: "29",
        value: "10,185",
        logoURI:
          'https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599/logo.png',
      },
      {
        name: 'Dai Stablecoin',
        address: '0xaD6D458402F60fD3Bd25163575031ACDce07538D',
        symbol: 'DAI',
        decimals: 18,
          chainId: 3,
        amount: "24324",
        value: "3,185.32",
        logoURI:
          dai_icon,
      },
      {
        name: 'USDCoin',
        address: '0x07865c6e87b9f70255377e024ace6630c1eaa37f',
        symbol: 'USDC',
        amount: "0.00",
        chainId: 3,
        value: "10.37",
        logoURI:
          'https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48/logo.png',
      },
      {
        name: 'Dai Stablecoin',
        address: '0x6B175474E89094C44Da98b954EedeAC495271d0F',
        symbol: 'DAI',
        decimals: 18,
          chainId: 1,
        amount: "80323",
        value: 0.00,
        logoURI:
          'https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0x6B175474E89094C44Da98b954EedeAC495271d0F/logo.png',
      },
      {
        name: 'USDCoin',
        address: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
        symbol: 'USDC',
        decimals: 6,
          chainId: 1,
        amount: "1.64M",
        value: 0.00,
        logoURI:
          'https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48/logo.png',
      },
  
      {
        name: 'Wrapped BTC',
        address: '0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599',
        symbol: 'WBTC',
        decimals: 8,
        chainId: 1,
        value: 69.43,
        logoURI:
          'https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599/logo.png',
      },
]